(function() {
  angular.module("irricrops")

    .factory('mapFactory', ["$rootScope", function($rootScope) {

      var data = {
        sectores : []
      };

      var actualLayer = 'sector';

      var self = {
        data:data,
        getAll: function(){
          return data.sectores;
        },
        setLayer:function(newLayer) {
          actualLayer = newLayer;
        },
        getLayer:function() {
          return actualLayer;
        },

        setVinedo : function(vinedo){
          console.log("vinedo seteado : "+vinedo.id);
          data.vinedo = vinedo;
          // self.clear();
        },
        getVinedo: function(){
          return data.vinedo;
        },

        getDataServer:function(insMap,dataGeo, setCenter){
          setCenter = setCenter || false;
          var geo = dataGeo; //self.getSampleGeoJson();
          // var geo = self.getSampleGeoJson();

          //limpia el mapa
          insMap.map.data.forEach(function(feature){
            if (feature.getProperty('layer') != actualLayer && !(angular.isUndefined(feature.getProperty('layer')) && actualLayer == 'sector')) {
              insMap.map.data.remove(feature);
            }
          });


          // vm.cargarGeoJson = function(insMap){
          // var geo = mapFactory.getGeoJson();
          insMap.map.data.addGeoJson(geo);

          var featureCount = 0;
          var featureCountDisabled= 0;

          insMap.map.data.forEach(function(feature){
            featureCount++;
            if (feature.getProperty('layer') != actualLayer && !(angular.isUndefined(feature.getProperty('layer')) && actualLayer == 'sector')) {
              featureCountDisabled++;
              insMap.map.data.remove(feature);
            }
          });

          //set center and zoom
          if(angular.isDefined(geo.properties) && setCenter){
            var lat  = geo.properties.center.latitude;
            var lng  = geo.properties.center.longitude;
            var zoom = geo.properties.zoom;
            insMap.map.setCenter(new google.maps.LatLng(lat, lng));
            insMap.map.setZoom(zoom);
          }

          return featureCount - featureCountDisabled;

          // }
        },
        updateItemByShape: function(itemAux){
          angular.forEach(data.sectores, function(item){
            if (item.shape.type != google.maps.drawing.OverlayType.MARKER) {
              if(item.shape.getPath() == itemAux.shape){
                console.log("updated id: "+ item.id);
                item.id = angular.copy(itemAux.id);
                item.nombre = angular.copy(itemAux.nombre);
              }else{
                //TODO agregar escepcion para markers
              }
            }
          });
        },
        update: function(shape){
          angular.forEach(data.sectores, function(item){
            if (item.shape.type != google.maps.drawing.OverlayType.MARKER) {
              if(item.shape.getPath() == shape){
                console.log("updated id: "+ item.id);
                item.shape.setPath = shape;
              }else{
                //TODO agregar escepcion para markers
              }
            }
          });
        },
        getProp: function(shape){
          var a;
          angular.forEach(data.sectores, function(item){
            if(item.shape == shape){
              a = item;
            }
          });
          return a;
        },
        delete: function(shape){
          angular.forEach(data.sectores, function(item, index){
            if(item.shape == shape){
              console.log("delete id: "+item.id);
              data.sectores.splice(index, 1);
            }
          });
        },
        addShape: function(d){
          //
          //id: random FIXME
          //shape: poligon
          //
          data.sectores.push(d);
        },
        getGeoJson: function(callback){


          //google.maps.Map.prototype.getGeoJson=function(callback){
          var geo={"type": "FeatureCollection","features": []};
          var fx=function(g,t){

            var that  =[],
            arr,
            f     = {
              MultiLineString :'LineString',
              LineString      :'Point',
              MultiPolygon    :'Polygon',
              Polygon         :'LinearRing',
              LinearRing      :'Point',
              MultiPoint      :'Point'
            };

            switch(t){
              case 'Point':
                g=(g.get)?g.get():g;
                return([g.lng(),g.lat()]);
                //break;
              default:
                arr= g.getArray();
                for(var i=0;i<arr.length;++i){
                  that.push(fx(arr[i],f[t]));
                }
                if( t=='LinearRing' &&
                    that[0]!==that[that.length-1]){
                  that.push([that[0][0],that[0][1]]);
                }
                return that;
            }
          };

          angular.forEach(data.sectores, function(sector){

            var feature = {};
            switch(sector.shape.type){
              case google.maps.drawing.OverlayType.MARKER:
                feature = new google.maps.Data.Feature({geometry:new google.maps.Data.Point(sector.shape.getPosition())});
                break;
              case google.maps.drawing.OverlayType.RECTANGLE:
                var b=sector.shape.getBounds(),
                p=[b.getSouthWest(),{lat:b.getSouthWest().lat(),lng:b.getNorthEast().lng()},b.getNorthEast(),{lng:b.getSouthWest().lng(),lat:b.getNorthEast().lat()}];
                feature = new google.maps.Data.Feature({geometry:new google.maps.Data.Polygon([p])});
                break;
              case google.maps.drawing.OverlayType.POLYGON:
                feature = new google.maps.Data.Feature({geometry:new google.maps.Data.Polygon([sector.shape.getPath().getArray()])});
                break;
              case google.maps.drawing.OverlayType.POLYLINE:
                feature = new google.maps.Data.Feature({geometry:new google.maps.Data.LineString(sector.shape.getPath().getArray())});
                break;
              case google.maps.drawing.OverlayType.CIRCLE:
                feature = new google.maps.Data.Feature({properties:{radius:sector.shape.getRadius()},geometry:new google.maps.Data.Point(sector.shape.getCenter())});
                break;
            }


            var prop= {
              id: 1,
              label: sector.nombre || 'sin nombre',
              color: sector.color || '#0000FF',
              type: sector.type,
              alert: sector.alerta || false,
              showAlert: false,
              alertDisplayed: false
            };

            var _feature     = {type:'Feature',properties:prop};
            // var _id          = feature.getId();
            var _geometry    = feature.getGeometry();
            var _type        =_geometry.getType();
            var _coordinates = fx(_geometry,_type);

            _feature.geometry={type:_type,coordinates:_coordinates};
            // if(typeof _id==='string'){
            //   _feature.id=_id;
            // }

            geo.features.push(_feature);
            feature.forEachProperty(function(v,k){
              _feature.properties[k]=v;
            });
          });

          if(typeof callback==='function'){
            callback(geo);
          }

          return geo;
          //}


        },


        //http://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
        shadeRGBColor: function(color, percent) {
          var c=color.split("(")[1].split(")")[0],
              f=c.split(","),
              t=percent < 0 ? 0 : 255,
              p=percent < 0 ? percent*-1 : percent,
              R=parseInt(f[0]),
              G=parseInt(f[1]),
              B=parseInt(f[2]);
          return "rgb("+(Math.round((t-R)*p)+R)+","+(Math.round((t-G)*p)+G)+","+(Math.round((t-B)*p)+B)+")";
        },



        rgbify: function(val, minval, maxval, moreisgood) {
          var red   = "rgb(255, 0, 0)";
          var green = "rgb(0, 255, 0)";
          var yellow = "rgb(255, 255, 0)";

          if(val >= maxval){
            return  moreisgood ? green : red;
          }

          if(val <= minval){
            return  moreisgood ? red : green;
          }
          return yellow;



          //-------- Comentado, deprecado, pero no borrado
          var moreisgood = moreisgood || true;
          var intnsty = (val - minval) / (maxval - minval);
          var r, g;
          if (moreisgood) {
            if (intnsty > 0.5) {
              g = 255;
              r = Math.round(2 * (1 - intnsty) * 255);
            } else {
              r = 255;
              g = Math.round(2 * intnsty * 255);
            }

          } else { //lessisgood
            if (intnsty > 0.5) {
              r = 255;
              g = Math.round(2 * (1 - intnsty) * 255);
            } else {
              g = 255;
              r = Math.round(2 * intnsty * 255);
            }
          }
          return "rgb(" + r.toString() + ", " + g.toString() + ", 0)";
        },




        getColors: function(){
          var polygonsColors = [
            {
              background: "#FF7043",
              border:"#E64A19",
            },
            {
              background: "#42A5F5",
              border:"#1976D2",
            },
            {
              background: "#EC407A",
              border:"#C2185B",
            },
            {
              background: "#8BC34A",
              border:"#689F38",
            },
            {
              background: "#FFF176",
              border:"#FBC02D",
            },
            {
              background: "#8D6E63",
              border:"#5D4037",
            },
            {
              background: "#EF5350",
              border:"#B71C1C",
            },
            {
              background: "#AB47BC",
              border:"#7B1FA2",
            },
            {
              background: "#5C6BC0",
              border:"#303F9F",
            },
            {
              background: "#26C6DA",
              border:"#0097A7",
            },
            {
              background: "#26A69A",
              border:"#00796B",
            },
            {
              background: "#D4E157",
              border:"#AFB42B",
            },
            {
              background: "#7E57C2",
              border:"#512DA8",
            },
            {
              background: "#78909C",
              border:"#455A64",
            }
          ];
          return polygonsColors;
        },

        //https://www.mapbox.com/blog/polygon-center/
        //https://github.com/mapbox/polylabel
        getInnerCenter : function(feature){

          function TinyQueue(data, compare) {
            if (!(this instanceof TinyQueue)) return new TinyQueue(data, compare);

            this.data = data || [];
            this.length = this.data.length;
            this.compare = compare || defaultCompare;

            if (data) for (var i = Math.floor(this.length / 2); i >= 0; i--) this._down(i);
          }

          function defaultCompare(a, b) {
            return a < b ? -1 : a > b ? 1 : 0;
          }

          TinyQueue.prototype = {

            push: function (item) {
              this.data.push(item);
              this.length++;
              this._up(this.length - 1);
            },

            pop: function () {
              var top = this.data[0];
              this.data[0] = this.data[this.length - 1];
              this.length--;
              this.data.pop();
              this._down(0);
              return top;
            },

            peek: function () {
              return this.data[0];
            },

            _up: function (pos) {
              var data = this.data,
              compare = this.compare;

              while (pos > 0) {
                var parent = Math.floor((pos - 1) / 2);
                if (compare(data[pos], data[parent]) < 0) {
                  swap(data, parent, pos);
                  pos = parent;

                } else break;
              }
            },

            _down: function (pos) {
              var data = this.data,
              compare = this.compare,
              len = this.length;

              while (true) {
                var left = 2 * pos + 1,
                right = left + 1,
                min = pos;

                if (left < len && compare(data[left], data[min]) < 0) min = left;
                if (right < len && compare(data[right], data[min]) < 0) min = right;

                if (min === pos) return;

                swap(data, min, pos);
                pos = min;
              }
            }
          };

          function swap(data, i, j) {
            var tmp = data[i];
            data[i] = data[j];
            data[j] = tmp;
          }

          //module.exports = polylabel;
          //module.exports.default = polylabel;

          var Queue = TinyQueue;

          function polylabel(polygon, precision, debug) {
            precision = precision || 1.0;

            // find the bounding box of the outer ring
            var minX, minY, maxX, maxY;
            for (var i = 0; i < polygon[0].length; i++) {
              var p = polygon[0][i];
              if (!i || p[0] < minX) minX = p[0];
              if (!i || p[1] < minY) minY = p[1];
              if (!i || p[0] > maxX) maxX = p[0];
              if (!i || p[1] > maxY) maxY = p[1];
            }

            var width = maxX - minX;
            var height = maxY - minY;
            var cellSize = Math.min(width, height);
            var h = cellSize / 2;

            // a priority queue of cells in order of their "potential" (max distance to polygon)
            var cellQueue = new Queue(null, compareMax);

            if (cellSize === 0) return [minX, minY];

            // cover polygon with initial cells
            for (var x = minX; x < maxX; x += cellSize) {
              for (var y = minY; y < maxY; y += cellSize) {
                cellQueue.push(new Cell(x + h, y + h, h, polygon));
              }
            }

            // take centroid as the first best guess
            var bestCell = getCentroidCell(polygon);

            // special case for rectangular polygons
            var bboxCell = new Cell(minX + width / 2, minY + height / 2, 0, polygon);
            if (bboxCell.d > bestCell.d) bestCell = bboxCell;

            var numProbes = cellQueue.length;

            while (cellQueue.length) {
              // pick the most promising cell from the queue
              var cell = cellQueue.pop();

              // update the best cell if we found a better one
              if (cell.d > bestCell.d) {
                bestCell = cell;
                if (debug) console.log('found best %d after %d probes', Math.round(1e4 * cell.d) / 1e4, numProbes);
              }

              // do not drill down further if there's no chance of a better solution
              if (cell.max - bestCell.d <= precision) continue;

              // split the cell into four cells
              h = cell.h / 2;
              cellQueue.push(new Cell(cell.x - h, cell.y - h, h, polygon));
              cellQueue.push(new Cell(cell.x + h, cell.y - h, h, polygon));
              cellQueue.push(new Cell(cell.x - h, cell.y + h, h, polygon));
              cellQueue.push(new Cell(cell.x + h, cell.y + h, h, polygon));
              numProbes += 4;
            }

            if (debug) {
              console.log('num probes: ' + numProbes);
              console.log('best distance: ' + bestCell.d);
            }

            return [bestCell.x, bestCell.y];
          }

          function compareMax(a, b) {
            return b.max - a.max;
          }

          function Cell(x, y, h, polygon) {
            this.x = x; // cell center x
            this.y = y; // cell center y
            this.h = h; // half the cell size
            this.d = pointToPolygonDist(x, y, polygon); // distance from cell center to polygon
            this.max = this.d + this.h * Math.SQRT2; // max distance to polygon within a cell
          }

          // signed distance from point to polygon outline (negative if point is outside)
          function pointToPolygonDist(x, y, polygon) {
            var inside = false;
            var minDistSq = Infinity;

            for (var k = 0; k < polygon.length; k++) {
              var ring = polygon[k];

              for (var i = 0, len = ring.length, j = len - 1; i < len; j = i++) {
                var a = ring[i];
                var b = ring[j];

                if ((a[1] > y !== b[1] > y) &&
                (x < (b[0] - a[0]) * (y - a[1]) / (b[1] - a[1]) + a[0])) inside = !inside;

                minDistSq = Math.min(minDistSq, getSegDistSq(x, y, a, b));
              }
            }

            return (inside ? 1 : -1) * Math.sqrt(minDistSq);
          }

          // get polygon centroid
          function getCentroidCell(polygon) {
            var area = 0;
            var x = 0;
            var y = 0;
            var points = polygon[0];

            for (var i = 0, len = points.length, j = len - 1; i < len; j = i++) {
              var a = points[i];
              var b = points[j];
              var f = a[0] * b[1] - b[0] * a[1];
              x += (a[0] + b[0]) * f;
              y += (a[1] + b[1]) * f;
              area += f * 3;
            }
            if (area === 0) return new Cell(points[0][0], points[0][1], 0, polygon);
            return new Cell(x / area, y / area, 0, polygon);
          }

          // get squared distance from a point to a segment
          function getSegDistSq(px, py, a, b) {

            var x = a[0];
            var y = a[1];
            var dx = b[0] - x;
            var dy = b[1] - y;

            if (dx !== 0 || dy !== 0) {

              var t = ((px - x) * dx + (py - y) * dy) / (dx * dx + dy * dy);

              if (t > 1) {
                x = b[0];
                y = b[1];

              } else if (t > 0) {
                x += dx * t;
                y += dy * t;
              }
            }

            dx = px - x;
            dy = py - y;

            return dx * dx + dy * dy;
          }


          //llamado

          var fxC=function(g,t){

            var that  =[],
            arr,
            f     = {
              MultiLineString :'LineString',
              LineString      :'Point',
              MultiPolygon    :'Polygon',
              Polygon         :'LinearRing',
              LinearRing      :'Point',
              MultiPoint      :'Point'
            };

            switch(t){
              case 'Point':
                g=(g.get)?g.get():g;
                return([g.lng(),g.lat()]);
                //break;
              default:
                arr= g.getArray();
                for(var i=0;i<arr.length;++i){
                  that.push(fxC(arr[i],f[t]));
                }
                if( t=='LinearRing' &&
                    that[0]!==that[that.length-1]){
                  that.push([that[0][0],that[0][1]]);
                }
                return that;
            }
          };

          var coordinates = fxC(feature.getGeometry(), feature.getGeometry().getType());
          var c = polylabel(coordinates, 0.00001);
          return {
            lng: c[0],
            longitude: c[0],
            lat: c[1],
            latitude: c[1],
          }

        }








      };
      return self;
    }]);
})();
